
























































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Post as PostInterface } from "../../services/post/entities/post.interface";
import Divider from "../common/Divider.vue";
import BillboardDownload from "./BillboardDownload.vue";
@Component({
  components: {
    Divider,
    BillboardDownload,
  },
})
export default class Post extends Vue {
  @Prop() post!: PostInterface;
  emailDialog = false;
  $refs!: {
    downloadBtn: HTMLButtonElement;
  };
  private openURL(link: string): void {
    window.open(link);
  }
  handleDownload() {
    if (this.post.postFileRestricted) {
      this.emailDialog = true;
    } else {
      this.onDownload();
    }
  }
  onDownload() {
    this.$refs.downloadBtn?.click();
  }
}
